module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "detail-view"
  }, [_c('v-container', {
    attrs: {
      "fluid": "",
      "grid-list-md": ""
    }
  }, [_c('v-card', [_c('v-toolbar', {
    attrs: {
      "flat": ""
    }
  }, [(!_vm.noPathId) ? _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": _vm.exit
    }
  }, [_c('v-icon', [_vm._v("clear")])], 1) : _vm._e(), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _vm._l((_vm.buttons), function(button, i) {
    return [(_vm.canModifyNoDisable) ? _c('v-btn', {
      key: i,
      attrs: {
        "light": "",
        "color": button.color
      },
      on: {
        "click": function($event) {
          return button.function(_vm.item)
        }
      }
    }, [_vm._v(_vm._s(button.text))]) : _vm._e()]
  }), _vm._v(" "), (_vm.canModify) ? _c('v-btn', {
    staticClass: "mx-1",
    attrs: {
      "light": "",
      "color": "success"
    },
    on: {
      "click": function($event) {
        return _vm.saveItem(false)
      }
    }
  }, [_vm._v("Save")]) : _vm._e(), _vm._v(" "), (_vm.canDelete) ? _c('v-btn', {
    staticClass: "mx-1",
    attrs: {
      "light": "",
      "color": "error"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.showDeleteDialog = true
      }
    }
  }, [_vm._v("Delete")]) : _vm._e()], 2), _vm._v(" "), _c('v-form', {
    ref: "form",
    model: {
      value: (_vm.formValid),
      callback: function($$v) {
        _vm.formValid = $$v
      },
      expression: "formValid"
    }
  }, [_c('v-tabs', {
    attrs: {
      "color": "grey",
      "centered": "",
      "slider-color": "yellow"
    },
    model: {
      value: (_vm.tab),
      callback: function($$v) {
        _vm.tab = $$v
      },
      expression: "tab"
    }
  }, _vm._l((_vm.values), function(tab, i) {
    return _c('v-tab', {
      key: i,
      attrs: {
        "href": ("#tab-" + i)
      }
    }, [_vm._v(_vm._s(tab.name))])
  }), 1), _vm._v(" "), _c('v-tabs-items', {
    model: {
      value: (_vm.tab),
      callback: function($$v) {
        _vm.tab = $$v
      },
      expression: "tab"
    }
  }, _vm._l((_vm.values), function(tab, i) {
    return _c('v-tab-item', {
      key: i,
      attrs: {
        "value": ("tab-" + i)
      }
    }, [_c('v-card-text', [_vm._l((_vm.values[i].items), function(row, i) {
      return [_c('v-layout', {
        key: i,
        attrs: {
          "row": "",
          "wrap": ""
        }
      }, [_vm._l((row), function(value, j) {
        return [(value.type == 'checkbox') ? _c('v-flex', {
          key: j,
          class: value.width || _vm.itemWidth,
          staticStyle: {},
          attrs: {
            "align-end": ""
          }
        }, [_vm._v("\n                    " + _vm._s(value.name) + "\n                    "), _c('v-checkbox', {
          staticStyle: {
            "margin": "0px"
          },
          attrs: {
            "value": _vm.getElement(_vm.item, value.value),
            "hide-details": "",
            "disabled": value.disabled || !_vm.canModify
          },
          on: {
            "change": function (val) { return _vm.changeElement(_vm.item, value.value, val); }
          }
        })], 1) : (value.type == 'select') ? _c('v-flex', {
          key: j,
          class: value.width || _vm.itemWidth
        }, [_c('v-autocomplete', {
          attrs: {
            "clearable": "",
            "label": value.name,
            "item-text": value.itemText,
            "item-value": value.itemValue,
            "return-object": value.returnObject,
            "items": _vm.contextData[value.context],
            "value": _vm.getElement(_vm.item, value.value),
            "multiple": value.multiple,
            "chips": value.multiple,
            "deletable-chips": "",
            "rules": _vm.rulesInput(value.required, value.rule),
            "small-chips": value.multiple,
            "disabled": value.disabled || !_vm.canModify,
            "hide-details": "",
            "required": value.required
          },
          on: {
            "input": function (val) { return _vm.changeElement(_vm.item, value.value, val); }
          }
        })], 1) : (value.type == 'customType') ? _c('v-flex', {
          key: j,
          class: value.width || _vm.itemWidth
        }, [(value.value == null) ? _c('v-progress-circular', {
          attrs: {
            "indeterminiate": ""
          }
        }) : _c(value.value, _vm._b({
          tag: "component",
          on: {
            "input": function($event) {
              value.props.value ? function (val) { return _vm.changeElement(_vm.item, value.props.value, val); } : null
            }
          }
        }, 'component', _vm.getProps(value.props, value.contextual), false))], 1) : (value.type == 'combobox') ? _c('v-flex', {
          key: j,
          class: value.width || _vm.itemWidth
        }, [_c('v-combobox', {
          attrs: {
            "clearable": "",
            "label": value.name,
            "item-text": value.itemText,
            "item-value": value.itemValue,
            "return-object": value.returnObject,
            "items": _vm.contextData[value.context],
            "value": _vm.getElement(_vm.item, value.value),
            "multiple": value.multiple,
            "chips": value.multiple,
            "deletable-chips": "",
            "rules": _vm.rulesInput(value.required, value.rule),
            "disabled": value.disabled || !_vm.canModify,
            "hide-details": "",
            "required": value.required
          },
          on: {
            "input": function (val) { return _vm.changeElement(_vm.item, value.value, val); }
          }
        })], 1) : (value.type == 'date') ? _c('v-flex', {
          key: j,
          class: value.width || _vm.itemWidth
        }, [_c('date-view', {
          attrs: {
            "disabled": value.disabled || !_vm.canModify,
            "label": value.name
          },
          model: {
            value: (_vm.item[value.value]),
            callback: function($$v) {
              _vm.$set(_vm.item, value.value, $$v)
            },
            expression: "item[value.value]"
          }
        })], 1) : (value.type == 'duration') ? _c('v-flex', {
          key: j,
          class: value.width || _vm.itemWidth
        }, [_c('duration-view', {
          attrs: {
            "value": _vm.getElement(_vm.item, value.value),
            "disabled": value.disabled || !_vm.canModify,
            "label": value.name,
            "unit": value.valueType
          },
          on: {
            "input": function (val) { return _vm.changeElement(_vm.item, value.value, val); }
          }
        })], 1) : (value.type == 'itemList') ? _c('v-flex', {
          key: j,
          attrs: {
            "xs12": ""
          }
        }, [_c('item-list', {
          attrs: {
            "allowAdd": value.allowAdd,
            "allowDelete": value.allowDelete,
            "context": value.context,
            "editRoute": value.editRoute,
            "endpoint": value.value,
            "filter": _vm.populateFilters(value.filter, _vm.item),
            "headers": value.headers,
            "id": value.id,
            "loadData": _vm.dataLoaded,
            "model": value.model,
            "name": value.name,
            "pagination": value.pagination,
            "permissions": value.permissions
          },
          model: {
            value: (_vm.item[value.value]),
            callback: function($$v) {
              _vm.$set(_vm.item, value.value, $$v)
            },
            expression: "item[value.value]"
          }
        })], 1) : (value.type === 'expansionView') ? _c('v-flex', {
          key: j,
          attrs: {
            "xs12": ""
          }
        }, [_c('expansion-view', {
          attrs: {
            "endpoint": value.endpoint,
            "site": value.site
          }
        })], 1) : (value.type === 'component') ? _c('v-flex', {
          key: j,
          attrs: {
            "xs12": ""
          }
        }, [_c(value.component, {
          tag: "component",
          attrs: {
            "prefix": value.prefix,
            "value": _vm.getElement(_vm.item, value.value)
          },
          on: {
            "input": function (val) { return _vm.changeElement(_vm.item, value.value, val); },
            "change": function($event) {
              return _vm.saveItem(true)
            }
          }
        })], 1) : (value.type === 'formatTime') ? _c('v-flex', {
          key: j,
          class: value.width || _vm.itemWidth
        }, [_c('v-text-field', {
          attrs: {
            "label": value.name,
            "value": _vm.getTimeElement(_vm.item, value.value),
            "required": value.required,
            "disabled": value.disabled || !_vm.canModify,
            "rules": _vm.rulesInput(value.required, value.rule),
            "hide-details": ""
          },
          on: {
            "change": function (val) { return _vm.changeElement(_vm.item, value.value, val, value.valueType); }
          }
        })], 1) : _c('v-flex', {
          key: j,
          class: value.width || _vm.itemWidth
        }, [_c('v-text-field', {
          attrs: {
            "label": value.name,
            "value": _vm.getElement(_vm.item, value.value),
            "required": value.required,
            "disabled": value.disabled || !_vm.canModify,
            "rules": _vm.rulesInput(value.required, value.rule),
            "hide-details": ""
          },
          on: {
            "change": function (val) { return _vm.changeElement(_vm.item, value.value, val, value.valueType); }
          }
        })], 1)]
      })], 2), _vm._v(" "), _c('v-divider', {
        key: i + 10000
      }), _vm._v(" "), _c('br', {
        key: i + 20000
      }), _vm._v(" "), _c('v-divider', {
        key: i + 30000
      })]
    })], 2)], 1)
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "max-width": "300px"
    },
    model: {
      value: (_vm.showDeleteDialog),
      callback: function($$v) {
        _vm.showDeleteDialog = $$v
      },
      expression: "showDeleteDialog"
    }
  }, [_c('v-card', [_c('v-card-title', [_c('div', {
    staticClass: "headline"
  }, [_vm._v("Delete?")])]), _vm._v(" "), _c('v-card-text', [_vm._v("Are you sure you want to delete this " + _vm._s(_vm.name) + "?  This action cannot be undone.")]), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.showDeleteDialog = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": "",
      "color": "red"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.deleteItem.apply(null, arguments)
      }
    }
  }, [_vm._v("I'm Sure")])], 1)], 1)], 1), _vm._v(" "), _c('error-snackbar', {
    model: {
      value: (_vm.errorText),
      callback: function($$v) {
        _vm.errorText = $$v
      },
      expression: "errorText"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2f773b96","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/@sdgsystems/vue-common/components/DetailView.vue
// module id = 433
// module chunks = 1